/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  function configurer(){
    $('#menu-bt').on('click', function() {

      if($('#main-navigation').hasClass('open')) {
        closeMenu();
      }else {
        openMenu();
      }

    });

    $('#newsletter-popup .close-video').on('click', function() {
      $('#newsletter-popup').fadeOut();
    });

    $('#newsletter-open').on('click', function() {
      $('#newsletter-popup').fadeIn();
    });

    //Anchor animations
    $('a[href^="#"]').on('click touchend', function() {
      var the_id = $(this).attr("href");
      if(the_id !== '#') {

        $('html, body').animate({
          scrollTop: $(the_id).offset().top
        }, 'slow');

      }
      return false;

    });



     var lastScrollTop = 0;
    $(window).scroll(function(event){
       var st = $(this).scrollTop();
       if (st > lastScrollTop){
          $('#main-header').addClass('no-shadow');
          $('#main-header').addClass('scroll');
       } else {
          $('#main-header').removeClass('scroll');
          $('#main-header').removeClass('no-shadow');
       }
       lastScrollTop = st;

       if($(window).width() < 768){
          if($('#main-header').hasClass('scroll')) {
            closeMenu();
          }
       }

    });
      

    $('.image-slider').slick({
      dots: false,
      arrows: true,
      slidesToShow: 1,
    });

    $('.orange-slider').slick({
      dots: true,
      arrows: false,
      slidesToShow: 1,
      autoplay: true,
    });

    $('.temoignages-slider').slick({
      dots: true,
      arrows: false,
      slidesToShow: 3,
      infinite: true,
      responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2
        }
      },{
        breakpoint: 768,
        settings: {
          slidesToShow: 1
        }
      }
    ]
    })

     if($(window).width() > 1024){
          var slidesToShow =  3;
        }else {
          if($(window).width() < 768) {
            var slidesToShow =  1;
          }else {
           var slidesToShow =  2;
          }
        }

    $('.phases-slider').slick({
      dots: false,
      arrows: true,
      slidesToShow: slidesToShow,
      infinite: false,
      responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2
        }
      },{
        breakpoint: 768,
        settings: {
          slidesToShow: 1
        }
      }
    ]
    });

    $('.phases-slider').on('beforeChange', function(event, slick, currentSlide, nextSlide){

        if($(window).width() > 1024){
          var slidesToShow =  3;
        }else {
          if($(window).width() < 768) {
            var slidesToShow =  1;
          }else {
           var slidesToShow =  2;
          }
        }


        if (slick.$slides.length == (nextSlide+slidesToShow)) {
            $('.phases-slider').addClass('last');
        }else {
          $('.phases-slider').removeClass('last');
        }
    });

    //Gestion des accordéons  
    $('.accordeon').on('click', function() {
      $(this).toggleClass('open');
      $(this).find('.contenu').slideToggle();

      var current = $(this);

      setTimeout(function(){ 
        current.toggleClass('txt-visible');
      }, 500);

    });

    //Selects
    $('.select-wrapper').each(function(){
      $(this).find('.option-title').attr('disabled', 'disabled');
    });


    if($(window).width() > 1024) {

      $('.select-container').each(function() {
        var current = $(this);
        populateSelect(current);
      });

    }

    $('select').on('click', function(e) {
      e.preventDefault();
    });

    //Radios
    $('.radio-section.to-wrap input[type="radio"]').each(function() {
      $(this).parent().wrap('<label class="radio-container"></label>');
      $(this).parent().append('<span class="checkmark"></span>');
    });

    //TABS

    var totalWidth = 30;

    $('.tab-actions li').each(function() {
      

      var elementWidth = $(this).outerWidth(true);

      $(this).attr('data-width', elementWidth);


      totalWidth = totalWidth+elementWidth;


    });

    $('.tab-actions').css('min-width', totalWidth);

    $('.tab-actions li').on('click', function() {
      $('.tab-actions li.active').removeClass('active');
      $(this).addClass('active');

      var selectedId = $(this).attr('data-tab');

      openCloseTabs(selectedId);

    });

    $('.form-trigger').on('click', function() {
      $('.form-wrapper').slideToggle(); 
    })

    //LANDING
    $('.slider-temoignage').slick({
      arrows: false,
      dots: true,
      fade: true
    });

    var divs = $("#blogue-posts-list .col");
    for(var i = 0; i < divs.length; i+=3) {
      divs.slice(i, i+3).wrapAll("<div class='load-more-page hidden'><div class='load-more-page-wrapper'></div></div>");
    }

    $('#blogue-load-more a.btn').on('click', function() {

      $('#blogue-posts-list .load-more-page.hidden').first().slideDown();
      setTimeout(function() {
        $('#blogue-posts-list .load-more-page.hidden').first().addClass('visible');      
        $('#blogue-posts-list .load-more-page.hidden').first().removeClass('hidden');   

        var availablepages = $('#blogue-posts-list .load-more-page.hidden').length;

        if(availablepages == 0){
          $('#blogue-load-more a.btn').css('opacity', 0);
          $('#blogue-load-more a.btn').css('cursor', 'default');
        }

      }, 350);


       

      return false;
    });

    //VIDEO
     $('.close-video').on('click', function() {
        closeVideoLightbox();
     });

     $('.video .video-trigger-wrapper').on('click', function() {
        var video_id = $(this).parent().find('.play-button').attr('data-id');
       openVideoLightbox(video_id);
     });

    $('#video-lightbox').on('click', function (){
      closeVideoLightbox();
    });

    //CALCULATEUR IMC
    $('#imc-calculate').on('click', calculateIMC);

    $(document).on('change','#imc-taille-select',function(){
        var mode_taille = $(this).val();

        if(mode_taille == "metre"){
          $('.imc-taille-pieds').slideUp();
          $('.imc-taille-metre').slideDown();
        }else {        
          $('.imc-taille-metre').slideUp();          
          $('.imc-taille-pieds').slideDown();
        }
    });

    //Liste des études
    $('#select-clinique select').on('change', function() {
      $('.etudes-list').css('opacity','0');
      setTimeout(function() {
        resetEtudesList();
      }, 500);      
    });

    $('#select-sexe select').on('change', function() {
      $('.etudes-list').css('opacity','0');
      setTimeout(function() {
        resetEtudesList();
      }, 500);
    });
    $('#select-age select').on('change', function() {
      $('.etudes-list').css('opacity','0');
      setTimeout(function() {
        resetEtudesList();
      }, 500);
    });
    $('#select-fumeur select').on('change', function() {
      $('.etudes-list').css('opacity','0');
      setTimeout(function() {
        resetEtudesList();
      }, 500);
    });
    

    //FAQ
    $('#faq-form form').on('submit', function(e) {
      var search = $('#faq-query').val();

      $('.faq-results .accordeon').each(function(e) {

        var title = $(this).find('p.titre').text();
        var contenu = $(this).find('.contenu').text();

        var inTitle = faqSearchTitle(search, title);
        var inContent = faqSearchContent(search, contenu);

        var current =  $(this);

        faqResetGrid();

        setTimeout(function() {

          if(inTitle || inContent){
            current.slideDown(); 
          }else {
            current.slideUp();
          }

        }, 500);

        

      });

      e.preventDefault();

      return false;
    });


    if($('body').hasClass('single-etude')){

      var etudeName = $('#etude-header h1').text();

      $('#input_5_13').val(etudeName);

    }

  }

  function faqResetGrid(){
    $('.faq-results').css('opacity', 0);

    setTimeout(function() {

           $('.faq-results').css('opacity', 1);

    }, 1000);


  }

  function faqSearchContent(search, content){

    if (content.indexOf(search) > -1) {
      return true;
    } else {
      return false;
    }

  }

  function faqSearchTitle(search, title){


    if (title.indexOf(search) > -1) {
      return true;
    } else {
      return false;
    }

  }

  function resetEtudesList() {
   

      var idClinique = $("#select-clinique select").val();
      var idSexe = $("#select-sexe select").val();      
      var idAge = $("#select-age select").val();
      var idFumeur = $("#select-fumeur select").val();

      if(idClinique == "-1" && idSexe == "-1"){
        $('.etudes-list .etude-list-item').each(function() {
          $(this).slideDown();
        });
      }else {
        
        $('.etudes-list .etude-list-item').each(function() {
          var currentCliniqueId = $(this).attr('data-clinique');
          var currentGenre = $(this).attr('data-genre');
          var currentAgeMin = $(this).attr('data-age-min');
          var currentAgeMax = $(this).attr('data-age-max');
          var currentFumeur = $(this).attr('data-fumeur');
          
          var visible = true;

          if(idSexe && idSexe !== "-1" && visible == true){
            visible = checkGenderEtude(currentGenre);
          }

          if(idClinique && idClinique !== "-1" && visible == true){
            visible = checkCliniqueEtude(currentCliniqueId);
          }

          if(idAge && idAge !== "-1" && visible == true){
            visible = checkAgeEtude(currentAgeMin, currentAgeMax);
          }

          console.log(idFumeur);

          if(idFumeur && idFumeur !== "-1" && visible == true){
            visible = checkFumeurEtude(currentFumeur);
          }

          if(visible){
            $(this).slideDown();
          }else {
            $(this).slideUp();
          }

        });      

      }

      setTimeout(function() {
        $('.etudes-list').css('opacity','1');
      }, 500);
      

      
  }

  function checkGenderEtude(currentGenre){
    var idSexe = $("#select-sexe select").val();

    if(idSexe == "3"){
      return true;
    }else {
      if(idSexe !== currentGenre){
        return false;
      }else {
        return true;
      }
    }   

  } 

  function checkAgeEtude(ageMin, ageMax) {

    var idAge = $("#select-age select").val();

    idAge = idAge.split('-');
    var idAgeMin = idAge[0];
    var idAgeMax = idAge[1];

    if(idAge == "-1"){
      return true;
    }else {
      if(parseInt(idAgeMin) <= parseInt(ageMin)  && parseInt(idAgeMax) >= parseInt(ageMax)){
        return true;
      }else {
        return false;
      }
    }   

  }

  function checkFumeurEtude(currentFumeur) {
    var idFumeur = $("#select-fumeur select").val();

    console.log(idFumeur);
    console.log(currentFumeur);

    if(idFumeur == "2"){
      return true;
    }else {
      if(idFumeur !== currentFumeur){
        return false;
      }else {
        return true;
      }
    }   
  }

  function checkCliniqueEtude(currentCliniqueId) {
      
      var idClinique = $("#select-clinique select").val();

      var arrCliniquesId = currentCliniqueId.split(",");

      if(jQuery.inArray(idClinique, arrCliniquesId) !== -1){
        return true;
      }else {
        return false;
      }
  } 

  function calculateIMC() {

    var poid_type = $('.calculateur-imc-poid select').val();
    var poid = $('input[type="number"].poids').val();

    var taille_type = $('#imc-taille-select').val();
    var taille = $('input[type="number"].poid-metre').val();

    if(poid_type == 'lbs'){
      //Poid en LBS
      poid = poid/2.2046;
    }

    if(taille_type == 'pied'){
      //Taille en pied/pouce

      var pied = parseInt($('.poid-pied').val());
      var pouce = parseFloat($('.poid-pouce').val());

      if(pouce){
        pouce = pouce/12;
        var piedpouce = pied+pouce;
      }else {
        piedpouce = pied;
      }      

      taille = piedpouce/3.2808;

    }

    if(taille && poid !== 0){
      var calculatedIMC = poid/(taille*taille);
      calculatedIMC = calculatedIMC.toFixed(2)

      $('.calculateur-imc-result').html(calculatedIMC);   

      $('.calculateur-imc-result-wrapper').slideDown();
    }else {
      $('.calculateur-imc-result-wrapper').slideUp();
    }

  }

  function openCloseTabs(tabIndex) {

    $('.tab-contents .tab-panel.active').slideUp();

    $('.tab-contents .tab-panel[data-tab="'+tabIndex+'"]').slideDown();
    $('.tab-contents .tab-panel[data-tab="'+tabIndex+'"]').addClass('active');
  }

  function closeMenu(){
      $('#main-navigation').removeClass('open');
      $('#main-header').removeClass('menu-open');
  }

  function openMenu() {

      $('#main-navigation').addClass('open');
      $('#main-header').addClass('menu-open');
  }

  function populateSelect(element) {

    var options = element.find('.select-wrapper select > option');

    element.append("<ul class='options'></ul>");
    element.find('.select-wrapper').append("<span class='select-action'>");


    element.find('.select-action').on('click', function() {
      var current = $(this);

      selectToggle(current);

    });

    options.each(function() {
      var val = $(this).val();
      var text = $(this).text();
      var disabled = $(this).attr('disabled');

      if(!disabled && val){
        element.find('.options').append("<li data-value="+val+">"+text+"</li>");
      }

    });

    $('.options li').on('click', function() {
      
      var current =  $(this);
      var value = current.attr('data-value');
      current.parent().parent().find('select').val(value);
      current.parent().parent().find('select option[value="'+value+'"]').prop('selected', true);
      current.parent().parent().find('select').addClass('orange');

      current.parent().parent().find('select').change();

      selectClose(current);

    });


  }

  function selectToggle(element) {
    element.parent().parent().find(".options").slideToggle();
  }

  function selectClose(element){
    element.parent().slideUp();
  }

  function closeVideoLightbox(){

    var cleanSrc = $('.video-iframe.visible').attr('clean-src');
    $(".video-iframe.visible iframe")[0].src = cleanSrc;
    

    $('#video-lightbox').addClass('hidden');
  
    $('#video-lightbox').addClass('visually-hidden');

    setTimeout(function() {
         $(".video-iframe.visible").removeClass('visible');
      }, 500);

    $('body').removeClass('no-scroll');
    
  }

  function openVideoLightbox(videoid){


      $('body').addClass('no-scroll');

      $('#video-lightbox').removeClass('hidden');
      $('#video-lightbox').removeClass('visually-hidden');

      $('#video-lightbox .video-iframe[data-id="'+videoid+'"]').addClass('visible');

      var cleanSrc = $('#video-lightbox .video-iframe[data-id="'+videoid+'"] iframe')[0].src;

      $('#video-lightbox .video-iframe[data-id="'+videoid+'"]').attr('clean-src', cleanSrc);

      if(cleanSrc.indexOf('vimeo') == -1){
        $('#video-lightbox .video-iframe[data-id="'+videoid+'"] iframe')[0].src += "&background=1";
      }
      
      $('#video-lightbox .video-iframe[data-id="'+videoid+'"] iframe')[0].src += "&autoplay=1";

  }


  window.onload = configurer;

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
